import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

const entries = [
  {
    title: "电影",
    to: "/category/电影",
    icon: "ri-film-line",
    desc: "院线热片与经典高分",
    type: "电影" as const,
  },
  {
    title: "电视剧",
    to: "/category/电视剧",
    icon: "ri-tv-2-line",
    desc: "国产剧集与海外口碑剧",
    type: "电视剧" as const,
  },
  {
    title: "综艺",
    to: "/category/综艺",
    icon: "ri-mic-line",
    desc: "真人秀、竞演与纪实",
    type: "综艺" as const,
  },
  {
    title: "看片APP",
    to: "/app",
    icon: "ri-app-store-line",
    desc: "8 款主流看片工具",
    type: null,
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full max-w-page mx-auto px-4 md:px-8 -mt-8 md:-mt-10 relative z-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {entries.map((entry) => {
          const count = entry.type
            ? movies.filter((movie) => movie.type === entry.type).length
            : 8;
          return (
            <Link
              key={entry.title}
              to={entry.to}
              className="group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/80 hover:border-accent-300 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors">
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900">{entry.title}</h3>
                  <span className="text-[11px] text-foreground-400 font-label">{count} 部</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500 truncate">{entry.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-accent-600 transition-colors"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}